(function ($, window) {
    $(function () {
        $('.c-news-slider').slick({
            slidesToShow: 3,
            slidesToScroll: 3,
            swipeToSlide: true,
            arrows: true,
            appendArrows: $('.c-news-slider-arrows-container'),
            centerPadding: '0',
            draggable: true,
            infinite: false,
            lazyLoad: 'ondemand',
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        $('.c-person-slider').on('init', function(slick){
            var fancybox_touch = $(window).width() <= 992 ? true : false;

            $('.call-modal').fancybox({
                type: 'ajax',
                buttons: [
                    "close"
                ],
                touch: fancybox_touch
            });
        });

        $('.c-person-slider').slick({
            slidesToShow: 5,
            slidesToScroll: 3,
            swipeToSlide: true,
            arrows: true,
            centerPadding: '0',
            draggable: true,
            infinite: false,
            lazyLoad: 'ondemand',
            variableWidth: true,
            responsive: [
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1
                    }
                }
            ]
        });
    });
})(jQuery, window);